<template>
    <div id="chart-preferences" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Chart Preferences</h5>
                </div>
                <div class="modal-body">
                    <div class="input-group">
                        <select class="custom-select" id="chart-type" name="chart_type" v-model="selectedChart">
                            <option v-for="chart in charts" :key="chart.id" :value="chart">{{ chart.title }}</option>
                        </select>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" @click="add()">Add</button>
                        </div>
                    </div>
                    <div v-if="selectedChart" class="m-3 text-muted pb-2 border-bottom">
                        <h6 class="font-weight-bold">{{ selectedChart.title }}</h6>
                        <span class="chart-description">{{ selectedChart.description }}</span>
                    </div>
                    <div class="container mt-3">
                        <div v-for="(cols, i) in rows" :key="'row-' + i" class="row">
                            <div v-for="(col, j) in cols" :key="'col-' + j" class="col text-center">
                                <div class="card mb-2">
                                    <div class="card-title mb-0 pb-0 mt-1 mr-2">
                                        <button type="button" class="close" @click="remove(col.id)">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>                                     
                                    <div class="card-body mt-0 pt-0">                                        
                                        <i class="fas fa-chart-line text-muted"></i>
                                        <div class="title">{{ col.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            charts: [],
            userCharts: [],
            selectedChart: null
        }
    },
    computed: {
        rows: function () {
            return _.chunk(this.userCharts, 2);
        }
    },
    methods: {
        show: function () {
            axios.get('/ajax/dashboard/preferences')
            .then(response => {

                this.charts = response.data.charts;
                this.userCharts = response.data.userCharts;

                if (this.charts.length) {
                    this.selectedChart = this.charts[0];
                }

                $('#chart-preferences').modal('show');
            })
            .catch(error => {

            });
        },
        add: function () {
            this.userCharts.push(this.selectedChart);
        },
        remove: function (id) {
            let index = this.userCharts.findIndex((e) => { return e.id == id; });
            if (index > -1) {
                this.userCharts.splice(index, 1);
            }
        },
        save: function () {
            axios.patch('/ajax/dashboard/preferences', {
                'charts': this.userCharts.map(e => e.id)
            })
            .then(response => {
                $('#chart-preferences').modal('hide');
                location.reload(true);
            })
            .catch(error => {
                console.log(error.response.data);
                $('#chart-preferences').modal('hide');
            });            
        }
    },
    created() {
        eventHub.$on('chart-preferences', this.show);
    },
    beforeDestroy() {
        eventHub.$off('chart-preferences');
    }
}
</script>

<style scoped>
    .title {
        display: block;
        font-size: .60em;
        padding: 0;
        margin: 0;
    }

    .chart-description {
        font-size: .95em;
    }
</style>